import { getRequest } from "../utils/api";

export const listGeneralStatusApi = {
  listGeneralStatus: ({ limit, offset, active = true }) =>
    getRequest(
      `/general/status?${new URLSearchParams({ limit, offset, active })}`,
      {}
    ),
};
